const Heading = ({ title, className }: { title: string, className?: string }) => {
  return <h2 className={`text-left text-xl md:text-2xl font-bold text-storyblue ${className}`}>{title}</h2>;
};

export default Heading;